const winningTeamData = [
  {
    problem: "PS1",
    name: "Gravity Falls",
    college: "Thapar Institute For Engineering and Technology",
    leader: "Smriddhi Sahni",
    member1: "Divyansh Kalia",
    member2: "Swayansu S Baral",
    member3: "Arjan Singh Sandhu",
  },
  {
    problem: "PS2",
    name: "CHATGDP",
    college: "International Institute of Information Technology, Naya Raipur",
    leader: "Ravil Patel",
    member1: "Shivam Kushwaha",
    member2: "Sanskar Singh",
    member3: "Shivaibhav Dewangan",
    member4: "Aman Sahu",
    member5: "Rigved Desai",
  },
  {
    problem: "PS3",
    name: "The Phantom Troupe",
    college: "National Institute of Technology Raipur",
    leader: "Premchand Maddikuntla",
    member1: "Prudhvi Thimmareddy",
    member2: "Varun Reddy K",
    member3: "Alim Khan",
  },
  {
    problem: "PS4",
    name: "Forty Two",
    college: "National Institute Of Technology, Raipur",
    leader: "Pramil Kesarwani",
    member1: "Pratham Gandhi",
    member2: "Aditya Ray",
    member3: "Geddada Chandrika",
    member4: "Utkarsh Maurya",
    member5: "Ritesh Bhartiya",
  },
  {
    name: "Lorem Ipsum",
    college: "Government Engineering College, Raipur",
    leader: "Yash Joglekar ",
    member1: "Abhinav Sharma",
    member2: "Chandan Kumar Soni",
    member3: "Devesh Swarnkar",
    member4: "Krishna Dubey",
    member5: "Nitish Kumar Kushwaha",
  },
];

export default winningTeamData;
